import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Play } from 'lucide-react';

const TaxStrategies = () => {
  const videos = [
    {
      id: 1,
      url: 'https://youtube.com/shorts/lqCDK8EmJ9Q?feature=share',
      title: 'How are we going to pay for this mess?',
      thumbnail: 'https://img.youtube.com/vi/lqCDK8EmJ9Q/maxresdefault.jpg'
    },
    {
      id: 2,
      url: 'https://youtube.com/shorts/QhvVsrWawdk?feature=share',
      title: 'Different buckets of money',
      thumbnail: 'https://img.youtube.com/vi/QhvVsrWawdk/maxresdefault.jpg'
    },
    {
      id: 3,
      url: 'https://youtube.com/shorts/CZ9Brqf3zVg',
      title: 'Tax loophole for ROTH conversions',
      thumbnail: 'https://img.youtube.com/vi/CZ9Brqf3zVg/maxresdefault.jpg'
    },
    {
      id: 4,
      url: 'https://youtube.com/shorts/-6dIkkW8FNw',
      title: 'Getting to the zero % tax bracket',
      thumbnail: 'https://img.youtube.com/vi/-6dIkkW8FNw/maxresdefault.jpg'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Excerpts from one of Dan's Seminars
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            RMD ages, contribution amounts and the tax table has changed since these recordings but the concepts are timeless.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {videos.map((video) => (
            <Card key={video.id} className="overflow-hidden hover:shadow-lg transition-shadow">
              <CardContent className="p-0">
                <a href={video.url} target="_blank" rel="noopener noreferrer">
                  <div className="aspect-[9/16] relative bg-gray-200 flex items-center justify-center">
                    <div className="relative w-full h-full">
                      <img 
                        src={video.thumbnail} 
                        alt={video.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                        <Play className="w-12 h-12 text-white" />
                      </div>
                    </div>
                  </div>
                </a>
                <div className="p-4">
                  <h3 className="font-semibold text-gray-900">{video.title}</h3>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TaxStrategies;